import {
  INICIALITZAR,
  INTRODUCCIO_OBTENIR_DADES
} from "../actions/actionTypes";

const ESTAT_INICIAL = {};

const especies = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${INTRODUCCIO_OBTENIR_DADES}_SUCCESS`:
      return action.payload && action.payload.especies
        ? action.payload.especies
        : {};

    default:
      return state;
  }
};

export const getEspecies = state => state.especies;

export const getEspeciesAsArray = state => {
  const especiesIndexatsPerId = getEspecies(state);
  return Object.keys(especiesIndexatsPerId).map(idEspecie => ({
    ...especiesIndexatsPerId[idEspecie],
    id: parseInt(idEspecie)
  }));
};

export default especies;
